var exports = {
  "Lw": "x61f99309--2f1870--overlay",
  "wG": "x61f99309--2f1870--loader",
  "u1": "x61f99309--2f1870--spinner",
  "Xy": "x61f99309--2f1870--scroll-to-message-spin",
  "SJ": "x61f99309--2f1870--cancel-button",
};

module.exports = exports;
